export enum DischargeOrderStatusChoices {
  HAS_ORDER = "HAS_ORDER",
  HAS_CONDITIONAL_ORDER = "HAS_CONDITIONAL_ORDER",
  MISSING_ORDER = "MISSING_ORDER",
}
